export const isExactMatch = (string, variable) => {
    const regex = new RegExp(string)
  return variable?.match(regex)
}